import { Link } from "react-router-dom";
import styles from "../styles/Header.module.css";
import { useState } from "react";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Link to="/" className={styles.logo}>
          Portfolio
        </Link>

        {/* Hamburger Button for Mobile */}
        <button
          className={`${styles.hamburger} ${isMenuOpen ? styles.open : ""}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={styles.bar}></span>
          <span className={styles.bar}></span>
          <span className={styles.bar}></span>
        </button>

        {/* Navigation Menu */}
        <nav className={`${styles.nav} ${isMenuOpen ? styles.active : ""}`}>
          <Link
            to="/"
            className={styles.navLink}
            onClick={() => setIsMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/projects"
            className={styles.navLink}
            onClick={() => setIsMenuOpen(false)}
          >
            Projects
          </Link>
          <Link
            to="/Artworks"
            className={styles.navLink}
            onClick={() => setIsMenuOpen(false)}
          >
            Artworks
          </Link>
          <Link
            to="/about"
            className={styles.navLink}
            onClick={() => setIsMenuOpen(false)}
          >
            About
          </Link>
        </nav>
      </div>
    </header>
  );
};
